import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface MaskedPlaceholderProps {
  /** `CONTACT` gets its own sentence ("Phone number hidden…"); everything else the generic one. */
  kind?: string;
}

/**
 * The explicit "this is masked, not empty" placeholder for an inbound row without
 * `customers.feature.pii-view` (design §11.9, adr-merchant-portal-021 D4). Never render an empty
 * bubble for a masked message — a screen reader (and an operator) must hear *why* it is blank.
 */
export function MaskedPlaceholder({ kind }: MaskedPlaceholderProps) {
  const { t } = useTranslation('conversations');
  const message = kind === 'CONTACT' ? t('pii.phoneHidden') : t('pii.messageHidden');
  return (
    <Stack direction="row" spacing={0.75} alignItems="center">
      <VisibilityOffRoundedIcon aria-hidden fontSize="small" sx={{ color: 'text.disabled' }} />
      <Typography variant="body2" color="text.secondary" fontStyle="italic">
        {message}
      </Typography>
    </Stack>
  );
}
